import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { classNames } from '@geerd-nx/utils';
interface BrandedTextMenuProps {
  onChange?(value: any): void;
  selectOptions: {
    description: string;
    title: string;
  }[];
  selected: {
    description: string;
    title: string;
  };
}
export function BrandedTextMenu({
  onChange,
  selectOptions,
  selected,
}: BrandedTextMenuProps) {
  return (
    <Listbox value={selected} onChange={onChange}>
      {({ open }) => (
        <>
          <Listbox.Label className="sr-only">
            {' '}
            Change published status{' '}
          </Listbox.Label>
          <div className="relative">
            <div className="inline-flex divide-x divide-primary-600 rounded-md shadow-sm">
              <div className="inline-flex divide-x divide-primary-600 rounded-md shadow-sm">
                <div className="inline-flex items-center rounded-l-md border border-transparent bg-primary-500 py-2 pl-3 pr-4 text-white shadow-sm">
                  <CheckIcon className="h-5 w-5" aria-hidden="true" />
                  <p className="ml-2.5 text-sm font-medium">{selected.title}</p>
                </div>
                <Listbox.Button className="inline-flex items-center rounded-l-none rounded-r-md bg-primary-500 p-2 text-sm font-medium text-white hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50">
                  <span className="sr-only">Change published status</span>
                  <ChevronDownIcon
                    className="h-5 w-5 text-white"
                    aria-hidden="true"
                  />
                </Listbox.Button>
              </div>
            </div>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute right-0 z-10 mt-2 w-72 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {React.Children.toArray(
                  selectOptions.map((option) => (
                    <Listbox.Option
                      className={({ active }) =>
                        classNames(
                          active
                            ? 'text-white bg-primary-500'
                            : 'text-gray-900',
                          'cursor-default select-none p-4 text-sm'
                        )
                      }
                      value={option}
                    >
                      {({ selected, active }) => (
                        <div className="flex flex-col">
                          <div className="flex justify-between">
                            <p
                              className={
                                selected ? 'font-semibold' : 'font-normal'
                              }
                            >
                              {option.title}
                            </p>
                            {selected ? (
                              <span
                                className={
                                  active ? 'text-white' : 'text-primary-500'
                                }
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </div>
                          <p
                            className={classNames(
                              active ? 'text-primary-200' : 'text-gray-500',
                              'mt-2'
                            )}
                          >
                            {option.description}
                          </p>
                        </div>
                      )}
                    </Listbox.Option>
                  ))
                )}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}
